export interface OrderMetafield {
  date_created?: string;
  description: string;
  key: string;
  namespace: string;
  permission_set: OrderMetafieldPermission;
  resource_id?: number;
  resource_type?: 'category' | 'brand' | 'product' | 'variant' | 'order';
  date_modified?: string;
  value?: string;
}

export interface OrderMetaFieldKey {
  key: string;
  description?: string;
  value?: string;
}

export enum OrderMetafieldPermission {
  app_only = 'app_only',
  read = 'read',
  write = 'write',
  read_and_sf_access = 'read_and_sf_access',
  write_and_sf_access = 'write_and_sf_access',
}

export interface InvoiceHandler {
  orderId: number;
  customerId?: number;
  skipEmailSend?: boolean;
  isRefundInvoice?: boolean;
}

export interface InvoiceHandlerResponse {
  data: string;
  url: string;
}
